var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("img", {
    staticClass: "vimg lazyload",
    class: _vm.customClass,
    attrs: {
      src: _vm.placeholder,
      "data-src": _vm.fixedSize
        ? _vm.$image(_vm.media.src, _vm.fixedSize)
        : _vm.$image(_vm.media.src),
      "data-srcset": _vm.fixedSize ? "" : _vm.srcset,
      "data-sizes": "auto",
      alt: _vm.media.alt || _vm.$attrs.alt || "Image",
    },
    on: {
      lazyloaded: function ($event) {
        return _vm.$emit("loaded")
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }